// extracted by mini-css-extract-plugin
export default {"mystyle":"App_mystyle__6HN2i"};